import { ThemeParameters, RuntimeThemeParameters } from '../../types';
import { graphLabelText, graphDefault } from './';

export const graphValueText = (theme: ThemeParameters, parameters: RuntimeThemeParameters) => {
  const graphDefaultPattern = graphDefault(theme, parameters);
  const labelText = graphLabelText(theme, parameters);

  const common = {
    fontFamily: labelText.fontFamily,
    fontStyle: labelText.fontStyle,
    fontWeight: graphDefaultPattern.fontWeight.normal,
  };
  switch (theme.baseThemeName) {
    case 'dark': {
      return {
        ...common,
        textColor: graphDefaultPattern.n1,
        fontSize: graphDefaultPattern.fontSize.xs,
      };
    }
    case 'high-contrast': {
      return {
        ...common,
        textColor: labelText.textColor,
        fontSize: labelText.fontSize,
      };
    }
    default: {
      return {
        ...common,
        textColor: graphDefaultPattern.n_1,
        fontSize: graphDefaultPattern.fontSize.xs,
      };
    }
  }
};
